export const summonerSpellNameToKey = {
    "Barrier": "SummonerBarrier",
    "Cleanse": "SummonerBoost",
    "Flash": "SummonerFlash",
    "Flee": "SummonerCherryHold",
    "Ignite": "SummonerDot",
    "Exhaust": "SummonerExhaust",
    "Ghost": "SummonerHaste",
    "Heal": "SummonerHeal",
    "Clarity": "SummonerMana",
    "Smite": "SummonerSmite",
    "Snowball": "SummonerSnowball",
    "Teleport": "SummonerTeleport"
};
